import { ProviderContext, OptionsObject as NotistackOptionsObject, SnackbarKey, useSnackbar } from 'notistack';
import React from 'react';

import { SnackbarActions } from '../components/SnackbarActions/SnackbarActions';

type UndoHandler = () => void;
type CloseHandler = () => void;
interface UndoSnackOptions extends Omit<NotistackOptionsObject, 'action' | 'onClose'> {
  onUndo: UndoHandler;
  onClose?: CloseHandler;
}

function _enqueueUndoSnackbar(
  enqueueSnackbar: ProviderContext['enqueueSnackbar'],
  closeSnackbar: ProviderContext['closeSnackbar'],
  snackMessage: string,
  options: UndoSnackOptions
): SnackbarKey {
  const { autoHideDuration, onUndo, onClose, ...restOfOptions } = options;

  let undoDelete = false;
  const snackKey = enqueueSnackbar(snackMessage, {
    ...restOfOptions,
    autoHideDuration: autoHideDuration === undefined ? 15000 : autoHideDuration,
    onClose: (_event, reason, key) => {
      if (
        reason === 'timeout' ||
        reason === 'maxsnack' ||
        (reason === 'instructed' && snackKey === key && !undoDelete)
      ) {
        if (onClose) onClose();
      }
    },
    action: (key) => (
      <SnackbarActions
        onUndo={() => {
          onUndo();
          undoDelete = true;
          closeSnackbar(key);
        }}
        onClose={() => closeSnackbar(key)}
      />
    )
  });
  return snackKey;
}

export function useOurSnackbar() {
  const { enqueueSnackbar, closeSnackbar, ...rest } = useSnackbar();

  const enqueueUndoSnackbar = (snackMessage: string, options: UndoSnackOptions) => {
    return _enqueueUndoSnackbar(enqueueSnackbar, closeSnackbar, snackMessage, options);
  };
  return { ...rest, enqueueSnackbar, closeSnackbar, enqueueUndoSnackbar };
}
